import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Heart, Loader2, XCircle } from "lucide-react";
import { API } from "@/lib/api";

const Shell = ({ children, testId }) => (
  <section className="pt-40 pb-32 max-w-[900px] mx-auto px-5 md:px-10" data-testid={testId}>{children}</section>
);

const BackToSupport = () => (
  <Link to="/soutenir" data-testid="payment-back-link"
    className="inline-flex mt-10 border-2 border-white text-white font-display uppercase text-lg px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200">
    Retour à la page Soutenir
  </Link>
);

// Polls the payment until Stripe confirms it (max ~40 s)
export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(sessionId ? "pending" : "unknown");

  useEffect(() => {
    if (!sessionId) return undefined;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data?.payment_status === "paid") { setState("paid"); return; }
        if (["expired", "failed"].includes(data?.payment_status)) { setState("failed"); return; }
      } catch { /* keep polling */ }
      tries += 1;
      if (tries < 20) timer = setTimeout(poll, 2000);
      else setState("unknown");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <Shell testId="payment-success-page">
      {state === "pending" && (
        <p className="flex items-center gap-3 text-white text-xl" data-testid="payment-pending"><Loader2 className="w-6 h-6 animate-spin text-primary" /> On vérifie ton paiement…</p>
      )}
      {state === "paid" && (
        <div data-testid="payment-paid">
          <Heart className="w-10 h-10 text-primary" />
          <h1 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl text-white mt-6">Merci<span className="text-primary">.</span></h1>
          <p className="text-zinc-300 text-lg mt-4">Ton don est bien arrivé : il fait tourner la radio, l'agenda et le magazine LGTDZ. Un e-mail de remerciement vient de t'être envoyé.</p>
        </div>
      )}
      {state === "failed" && <p className="text-white text-xl" data-testid="payment-failed">Le paiement n'a pas abouti. Aucun montant n'a été prélevé.</p>}
      {state === "unknown" && <p className="text-white text-xl" data-testid="payment-unknown">Nous n'avons pas encore la confirmation du paiement. Si ta carte a été débitée, ton don est bien pris en compte.</p>}
      <BackToSupport />
    </Shell>
  );
}

export function PaymentCancel() {
  return (
    <Shell testId="payment-cancel-page">
      <XCircle className="w-10 h-10 text-primary" />
      <h1 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl text-white mt-6">Paiement annulé</h1>
      <p className="text-zinc-300 text-lg mt-4">Aucun montant n'a été prélevé. Tu peux réessayer quand tu veux.</p>
      <BackToSupport />
    </Shell>
  );
}
